// HOME
import { useNavigate, Link, useOutletContext, useLocation } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Carousel from "react-bootstrap/Carousel";
import Swal from "sweetalert2";
import HelmetSEO from '../../componentesEspeciales/helmetSEO';
// estilos
import '../../estilos/home.css';
// funciones
import { slugify } from "../../funcionesDatos/Textos";
import { pixelRegistroCompletado, pixelClickDescargaApp } from "../../funcionesDatos/pixelFacebook";
import { gtagRegistroCompletado, gtagClickDescargaApp } from "../../funcionesDatos/pixelGoogle";
import { ttqRegistroCompletado, ttqClickDescargaApp } from "../../funcionesDatos/pixelTiktok";
import { eventoRegistroCompletado, eventoClickDescargaApp, eventoOnboardingStep } from "../../funcionesDatos/eventoPropio";
// componentes
import ZonaCargando from '../alertas/zonaCargando';
import CardServicio from '../../componentesEspeciales/cardServicio';
import SeccionMapaHome from '../../componentesEspeciales/busqueda/seccionMapaHome';

function Home() {

  const navigate = useNavigate();
  const location = useLocation();

  const { usuario, cargandoUsuario, setUsuario } = useOutletContext() || {};

  // Detectar registro nuevo via Google (backend redirige con ?nuevo=true). Viene de registroInicio.js del registro de gogle. nuevoUsuarioGoogle._esNuevo = true;
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("nuevo") === "true") {
      pixelRegistroCompletado({ metodo: "google" });
      gtagRegistroCompletado({ metodo: "google" });
      ttqRegistroCompletado({ metodo: "google" });
      eventoRegistroCompletado({ metodo: "google", usuarioId: usuario?.idUsuario });
      eventoOnboardingStep({ step: "registro_completado", usuarioId: usuario?.idUsuario });
      navigate("/", { replace: true }); // limpiar ?nuevo=true de la URL
    }
  }, []);
  const [cargando, setCargando]     = useState(false);
  const cargandoFinal               = Boolean(cargandoUsuario) || Boolean(cargando);
  const [categorias, setCategorias] = useState([]);
  const [subCateg, setSubCateg]     = useState([]);
  const [imageCate, setImageCate]   = useState([]);
  const [populares, setPopulares]   = useState([]);
  const [servTop, setServTop]       = useState([]);
  // UI: búsqueda
  const [busqueda, setBusqueda]     = useState("");
  const [ciudad, setCiudad]         = useState("");
  // Evita slides vacíos en el hero si llega una imagen null, vacía o mal formada desde el backend.
  const imagenesHero = useMemo(() => {
    return (Array.isArray(imageCate) ? imageCate : [])
      .map((src) => (src || "").toString().trim())
      .filter((src) => src && (src.startsWith("http://") || src.startsWith("https://")));
  }, [imageCate]);


 


 
  // USEEFFECT PRINCIPAL
  useEffect(() => {
  (async () => {
    setCargando(true);
    try {
      // 1) Categorías
      try {
        const resCategorias = await axios.post("/obtener-categorias");
        if (resCategorias.status === 200) {
          setCategorias(resCategorias.data.categorias);
          setSubCateg(resCategorias.data.subcategorias);
          setImageCate(resCategorias.data.imagenesCategorias);
        }
      } 
      catch (err) { console.error("Error al obtener categorías:", err); }

      // 2) Populares
      try {
        const resPopulares = await axios.post("/obtener-categorias-populares", {
          params: {cantidad: 6}
        });
        setPopulares(resPopulares.data.categoriasPopulares);
      } 
      catch (err) { console.log("error al obtener categorias populares. ", err); }
      // 3) Servicios más contratados
      try {
        const resServicios = await axios.post("/obtener-servicios-mas-contratados", {
          params: {cantidad: 12}
        });
        setServTop(resServicios.data.serviciosContratados);
      } 
      catch (err) { console.log("error al obtener servicios top. ", err); }
    } 
    finally { setCargando(false); }
  })();
}, []);






  

  function handleBuscar(e) {
    e.preventDefault();

    const q = busqueda.trim();
    const c = ciudad.trim();

    // Enviamos filtros por state (interno), no por params en URL
    const filtros = {
      palabra: q || null,
      ciudad: c || null,
    };

    navigate("/busqueda", { state: { filtros } });
  }

  async function irACategoria(categoria) {
    const cat = (categoria || "").toString().trim();
    if (!cat) return navigate("/busqueda");

    const slug = await slugify(cat);
    navigate(`/categoria/${slug}`);
  }

  function enviarAIniciarSesion(returnTo) {
    navigate("/iniciar-sesion", { state: { returnTo } });
  }

  function enviarARegistrar(returnTo) {
    navigate("/registrar", { state: { returnTo } });
  }

  async function asegurarModoVendedorYContinuar(returnTo) {
    if (!usuario) return enviarAIniciarSesion(returnTo);

    if (usuario?.modo === "Vendedor") {
      navigate("/vendedor");
      return;
    }

    setCargando(true);
    try {
      const response = await axios.post("/cambiar-modo", {
        params: {
          usuario: usuario.username,
          modoActual: usuario.modo,
        }
      });

      if (response.status === 200) {
        const nuevoModo = response.data.nuevoModo;
        console.log("nuevo modo: ", nuevoModo);
        if (typeof setUsuario === "function") {
          setUsuario((prev) => {
            const base = (prev && typeof prev === "object") ? prev : usuario;
            return { ...(base || {}), modo: nuevoModo };
          });
        }

        if (nuevoModo === "Vendedor") {
          navigate("/vendedor", { replace: true });
          return;
        }
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No pudimos activar el modo vendedor. Intenta nuevamente.",
        customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
      });
    }
    catch (err) {
      console.log("Error cambiando a modo vendedor desde Home. ", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error cambiando el modo. Vuelve a intentar.",
        customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
      });
    }
    finally {
      setCargando(false);
    }
  }

  function irAPublicarServicio() {
    asegurarModoVendedorYContinuar("/vendedor/crear-editar-servicio");
  }

  function irAMisServicios() {
    asegurarModoVendedorYContinuar("/vendedor/servicios");
  }


  



  

 
  return (
    <div>
    <>
    <HelmetSEO
      titulo="Zervicy | Encuentra y reserva servicios en tu ciudad"
      descripcion="Reserva servicios confiables o publica tus habilidades en Zervicy. Mudanzas, mascotas, clases, limpieza, remodelaciones y más."
    />
    {cargandoFinal ? <ZonaCargando />
    : <div style={{ minHeight: "100vh" }}>
      {/* HERO: cambia según login */}
      {!usuario 
      /* SI NO HAY UN USUARIO LOGUEADO */
      ? <div className="">
          {/* HERO full-width: fondo/imagen ocupa todo, contenido queda dentro de container */}
          <div className="text-white position-relative estiloHero" style={{borderRadius: 0, paddingTop: "1.25rem", paddingBottom: "1.25rem", }} >

            {/* Fondo: Carousel (react-bootstrap) sin controles (solo fondo) */}
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
              <Carousel className="hero-carousel h-100" fade controls={false} indicators={false} interval={6500} pause={false}>
                {imagenesHero.map((src, idx) => (
                  <Carousel.Item className="h-100" key={src + idx}>
                    <img
                      src={src}
                      className="d-block w-100 h-100"
                      style={{ objectFit: "cover", objectPosition: "50% 50%", height: "100%" }}
                      alt=""
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            {/* Overlay azul (estilo actual) para que se vea marca y legible */}
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "linear-gradient(135deg, rgba(var(--azul-muy-oscuro-rgb), 0.88) 0%, rgba(var(--azul-gradiente-2-rgb), 0.72) 55%, rgba(var(--azul-gradiente-3-rgb), 0.62) 100%)", zIndex: 1, }} />

            {/* Contenido (en container) */}
            <div className="container position-relative" style={{ zIndex: 2 }}>
              <div className="row g-4 align-items-center py-3 py-md-4">
              {/* IZQUIERDA */}
              <div className="col-12 col-lg-7">
                {/* TITULO Y SUBTITULO */}
                <h1 className="display-6 fw-bold mb-1">Encuentra el servicio que necesitas, cuando lo necesitas.</h1>
                <p className="lead mb-3" style={{ opacity: 0.92 }}>
                  Contrata servicios confiables en minutos: paseos de perros, mudanzas, clases, remodelaciones, limpieza y más.
                </p>
                {/* CHIPS */}
                <div className="d-flex flex-wrap gap-2 mb-3">
                  <span className="px-3 py-2 rounded-pill estiloChip">Pagos seguros</span>
                  <span className="px-3 py-2 rounded-pill estiloChip" style={{ backgroundColor: "rgba(var(--rojo-error-rgb), 0.25)", borderColor: "rgba(var(--rojo-error-rgb), 0.5)" }}>
                    <i className="bi bi-lightning-charge-fill me-1" aria-hidden="true"></i>
                    Contrata en 2 horas
                  </span>
                  <span className="px-3 py-2 rounded-pill estiloChip">Soporte</span>
                  <span className="px-3 py-2 rounded-pill estiloChip">Calificaciones reales</span>
                </div>

                {/* FORMULARIO DE BÚSQUEDA */}
                <form onSubmit={handleBuscar} className="bg-white rounded-3 p-2 d-flex flex-column flex-md-row gap-2" style={{ maxWidth: 720 }}>
                  <input
                    className="form-control"
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    placeholder="¿Qué necesitas hoy? (ej: mudanza, pasear perro, remodelar baño)"
                  />
                  <input
                    className="form-control"
                    value={ciudad}
                    onChange={(e) => setCiudad(e.target.value)}
                    placeholder="Ciudad (opcional)"
                    style={{ maxWidth: 260 }}
                  />
                  <button className="btn btn-dark" type="submit" style={{ whiteSpace: "nowrap" }}>Buscar</button>
                </form>
                
                {/* BOTONES INICIAR SESIÓN Y REGISTRAR */}
                <div className="mt-3 d-flex flex-wrap gap-2" style={{ opacity: 0.95 }}>
                  <Link to="/iniciar-sesion" className="btn btn-outline-light">Iniciar sesión</Link>
                  <Link to="/registrar" className="btn btn-light">Crear cuenta</Link>
                </div>
              </div>
              
              {/* DERECHA */}
              <div className="col-12 col-lg-5">
                <div className="bg-white bg-opacity-10 border border-white border-opacity-25 rounded-4 p-4" style={{ backdropFilter: "blur(6px)" }}>
                  <div className="fw-semibold mb-2">Ejemplos populares</div>
                  <div className="d-grid gap-2">
                    {/* CATEGORÍAS POPULARES */}
                    {(Array.isArray(populares) && populares.length > 0)
                      ? populares.slice(0, 4).map((p, idx) => {
                        const nombre = (p?.categoria || p?.nombre || "").toString();
                        const icono = (p?.icono || "").toString();

                        return (
                          <button
                            key={(p?.categoria || p?.nombre || idx) + "-ej"}
                            type="button"
                            className="btn btn-outline-light text-start"
                            onClick={() => irACategoria(nombre)}
                            disabled={!nombre}
                          >
                            {/* ICONO CATEGORIA */}
                            {icono 
                            ? icono.includes(".svg") || icono.startsWith("http") 
                              /* SI EL ICONO EXISTE EN S3 */
                              ? <span
                                aria-hidden="true"
                                style={{
                                  width: 18,
                                  height: 18,
                                  marginRight: 8,
                                  display: "inline-block",
                                  backgroundColor: (p?.colorIcono || "var(--naranja-cta)"),
                                  WebkitMask: `url(${icono}) center / contain no-repeat`,
                                  mask: `url(${icono}) center / contain no-repeat`,
                                }}
                              />
                              /*SI NO, MUESTRA NADA*/
                              : <i className={icono} style={{ marginRight: 8 }} aria-hidden="true"></i>
                            : null}
                            {/* NOMBRE CATEGORIA */}
                            {nombre || "Categoría"}
                          </button>
                        );
                      })
                      /* SI NO CARGAN LAS CATEGORIAS*/
                      : <div>
                        <button type="button" className="btn btn-outline-light text-start" onClick={() => irACategoria("Aseo")}>🧼 Aseo</button>
                        <button type="button" className="btn btn-outline-light text-start" onClick={() => irACategoria("Mascotas")}>🐶 Mascotas</button>
                        <button type="button" className="btn btn-outline-light text-start" onClick={() => irACategoria("Transporte")}>🚚 Transporte</button>
                        <button type="button" className="btn btn-outline-light text-start" onClick={() => irACategoria("Construcción")}>🛠️ Construcción</button>
                      </div>
                    }
                  </div>
                  <div className="text-white-50 mt-3" style={{ fontSize: 13 }}>
                    Tip: escribe lo que necesitas y mira opciones cerca de ti.
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
      </div>
      /* SI YA HAY UN USUARIO LOGUEADO */
      : <div className="">
          {/* HERO full-width: fondo/imagen ocupa todo, contenido queda dentro de container */}
          <div className="text-white position-relative estiloHero" style={{ borderRadius: 0, paddingTop: "1.25rem", paddingBottom: "1.25rem" }}>

            {/* Fondo: Carousel (react-bootstrap) sin controles (solo fondo) */}
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
              <Carousel className="hero-carousel h-100" fade controls={false} indicators={false} interval={6500} pause={false}>
                {imagenesHero.map((src, idx) => (
                  <Carousel.Item className="h-100" key={src + idx + "-log"}>
                    <img
                      src={src}
                      className="d-block w-100 h-100"
                      style={{ objectFit: "cover", objectPosition: "50% 50%", height: "100%" }}
                      alt=""
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            {/* Overlay azul (estilo actual) para que se vea marca y legible */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ background: "linear-gradient(135deg, rgba(var(--azul-muy-oscuro-rgb), 0.88) 0%, rgba(var(--azul-gradiente-2-rgb), 0.72) 55%, rgba(var(--azul-gradiente-3-rgb), 0.62) 100%)", zIndex: 1, }}
            />

            {/* Contenido (en container) */}
            <div className="container position-relative" style={{ zIndex: 2 }}>
              <div className="p-4 text-white" style={{ borderRadius: 18, backdropFilter: "blur(6px)", background: "rgba(var(--blanco-rgb), 0.06)", border: "1px solid rgba(var(--blanco-rgb), 0.18)" }}>
                <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                  <div>
                    <div className="text-white-50" style={{ fontSize: 14 }}>Bienvenido</div>
                    <div className="h3 fw-bold mb-1">Hola{usuario?.nombre ? `, ${usuario.nombre}` : ""} 👋</div>
                    <div className="text-white-50" style={{ fontSize: 14 }}>¿Qué necesitas hoy?</div>
                  </div>

                  <form
                    onSubmit={handleBuscar}
                    className="bg-white rounded-3 p-2 d-flex flex-column flex-md-row gap-2"
                    style={{ width: "100%", maxWidth: 820 }}
                  >
                    <input
                      className="form-control"
                      value={busqueda}
                      onChange={(e) => setBusqueda(e.target.value)}
                      placeholder="Busca servicios (ej: pasear perro, mudanza, baño)"
                    />
                    <input
                      className="form-control"
                      value={ciudad}
                      onChange={(e) => setCiudad(e.target.value)}
                      placeholder="Tu ciudad (opcional)"
                      style={{ maxWidth: 260 }}
                    />
                    <button className="btn btn-dark" type="submit" style={{ whiteSpace: "nowrap" }}>Buscar</button>
                  </form>
                </div>

                <div className="mt-3 d-flex flex-wrap gap-2" style={{ opacity: 0.95 }}>
                  <span className="px-3 py-2 rounded-pill estiloChip">Recomendados</span>
                  <span className="px-3 py-2 rounded-pill estiloChip" style={{ backgroundColor: "rgba(var(--rojo-error-rgb), 0.25)", borderColor: "rgba(var(--rojo-error-rgb), 0.5)" }}>
                    <i className="bi bi-lightning-charge-fill me-1" aria-hidden="true"></i>
                    Contrata en 2 horas
                  </span>
                  <span className="px-3 py-2 rounded-pill estiloChip">Más contratados</span>
                  <span className="px-3 py-2 rounded-pill estiloChip">Cerca de ti</span>

                  <div className="ms-auto">
                    <button type="button" className="btn btn-light" onClick={irAPublicarServicio}>Publicar servicio</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      }

      {/* CONTENIDO PRINCIPAL */}
      <div className="container py-4">

        {/* 1) Categorías populares */}
        <div className="d-flex align-items-end justify-content-between mb-2">
          <div>
            <h2 className="h4 fw-bold mb-0">Categorías populares</h2>
            <div className="text-body-secondary" style={{ fontSize: 14 }}>Explora lo más solicitado.</div>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => navigate("/busqueda")}>Ver todas</button>
        </div>




        {/* CATEGORIAS POPULARES: fila de scroll horizontal a pantalla completa (rompe el container),
            así el nombre de cada categoría siempre cabe en una sola línea sin partirse en 2 renglones. */}
        <div className="categorias-slide-wrapper">
          <div className="categorias-slide">
            {populares.map((c, idx) => (
              <button
                key={(c?.categoria || idx) + "-cat"}
                type="button"
                onClick={() => irACategoria(c?.categoria)}
                className="card border-0 shadow-sm text-start categorias-slide-item position-relative overflow-hidden"
                style={{
                  borderRadius: 16,
                  backgroundColor: "rgba(var(--azul-muy-oscuro-rgb), 0.04)", /* fallback si no hay imagen */
                  backgroundImage: c?.imagen ? `url(${c.imagen})` : undefined,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  border: c?.imagen ? "1px solid rgba(var(--blanco-rgb), 0.18)" : "1px solid rgba(var(--azul-muy-oscuro-rgb), 0.10)",
                }}
              >
                {/* Overlay azul oscuro sobre la foto (mismo estilo que el hero) para que el icono y los textos resalten */}
                {c?.imagen && (
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "linear-gradient(135deg, rgba(var(--azul-muy-oscuro-rgb), 0.88) 0%, rgba(var(--azul-gradiente-2-rgb), 0.72) 55%, rgba(var(--azul-gradiente-3-rgb), 0.62) 100%)" }}
                    aria-hidden="true"
                  />
                )}

                <div className="card-body position-relative" style={{ zIndex: 1 }}>
                  <div className="d-flex align-items-center gap-3">
                    {/* ICONO */}
                    <div
                      className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: 44,
                        height: 44,
                        background: c?.imagen ? "rgba(var(--blanco-rgb), 0.12)" : "var(--azul-logo-fondo)", /* color del fondo del icono */
                        border: c?.imagen ? "1px solid rgba(var(--blanco-rgb), 0.22)" : "1px solid var(--azul-logo-fondo)",
                      }}
                    >
                      {(() => {
                        const icono = (c?.icono || "").toString();
                        if (!icono) return null;

                        // SVG por URL (S3): usamos mask para poder teñir
                        if (icono.includes(".svg") || icono.startsWith("http")) {
                          return (
                            <span
                              aria-hidden="true"
                              style={{
                                width: 22,
                                height: 22,
                                display: "inline-block",
                                backgroundColor: "var(--naranja-cta)", /* color del icono */
                                WebkitMask: `url(${icono}) center / contain no-repeat`,
                                mask: `url(${icono}) center / contain no-repeat`,
                              }}
                            />
                          );
                        }

                        // Emoji o texto corto
                        if (icono.length <= 4) {
                          return <span style={{ fontSize: 22 }}>{icono}</span>;
                        }

                        // Clase de icon-font (fallback)
                        return <i className={icono} aria-hidden="true" />;
                      })()}
                    </div>
                    {/* TEXTOS */}
                    <div className="text-start" style={{ minWidth: 0 }}>
                      <div className="fw-semibold text-truncate" style={{ color: c?.imagen ? "var(--blanco)" : "var(--azul-muy-oscuro)" }}>{c?.categoria || "Categoría"}</div>
                      <div style={{ fontSize: 13, color: c?.imagen ? "rgba(var(--blanco-rgb), 0.75)" : undefined }} className={c?.imagen ? "" : "text-body-secondary"}>Ver servicios</div>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* 1.5) Servicios cerca de ti (mapa) — justo debajo de categorías, es el componente más
            interactivo y el que más debe destacar para conversión. */}
        <SeccionMapaHome usuario={usuario} />



        {/* 2) Servicios más contratados */}
        <div className="mt-4 d-flex align-items-end justify-content-between mb-2">
          <div>
            <h2 className="h4 fw-bold mb-0">Servicios más contratados</h2>
            <div className="text-body-secondary" style={{ fontSize: 14 }}>Opciones top para empezar rápido.</div>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => navigate("/busqueda")}>Ver más</button>
        </div>

        <div className="row g-3">
          {(Array.isArray(servTop) ? servTop : []).slice(0, 12).map((s, idx) => {
            const id = s?.idServicio || s?.id || idx;

            return (
              <div key={id} className="col-12 col-sm-6 col-lg-3">
                <CardServicio
                  servicio={s}
                  clampDesc={4}
                  textoBoton="Ver servicio"
                  desdeDonde={"home"}
                />
              </div>
            );
          })}
        </div>


        {/* 3) Sección grande: cómo funciona Zervicy — solo para no logueados */}
        {!usuario && <section className="mt-5">
          <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: 24 }}>
            <div className="card-body p-0">

              {/* ENCABEZADO */}
              <div
                className="p-4 p-lg-5 text-white"
                style={{
                  background: "linear-gradient(135deg, var(--azul-logo-fondo) 0%, var(--azul-medio) 55%, var(--azul-logo-claro) 100%)",
                }}
              >
                <div className="row g-4 align-items-center">
                  <div className="col-12 col-lg-8">
                    <span
                      className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-3"
                      style={{ background: "rgba(var(--blanco-rgb), 0.12)", border: "1px solid rgba(var(--blanco-rgb), 0.20)", fontSize: 13 }}
                    >
                      <i className="bi bi-stars" aria-hidden="true"></i>
                      Marketplace de servicios
                    </span>
                    <h2 className="display-6 fw-bold mb-2">Así funciona Zervicy</h2>
                    <p className="lead mb-0" style={{ opacity: 0.92 }}>
                      Encuentra servicios confiables o empieza a vender tus habilidades desde un solo lugar.
                    </p>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div
                      className="rounded-4 p-3 h-100"
                      style={{ background: "rgba(var(--blanco-rgb), 0.10)", border: "1px solid rgba(var(--blanco-rgb), 0.20)", backdropFilter: "blur(6px)" }}
                    >
                      <div className="fw-bold mb-1">Tú creas el servicio.</div>
                      <div className="text-white-50" style={{ fontSize: 14 }}>
                        Zervicy te ayuda con la reserva, el pago, la comunicación y el seguimiento.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CAMINOS COMPRADOR / VENDEDOR */}
              <div className="p-4 p-lg-5">
                <div className="row g-4">

                  {/* COMPRADORES */}
                  <div className="col-12 col-lg-6">
                    <div
                      className="h-100 rounded-4 p-4"
                      style={{ background: "var(--color-bg-surface-alt)", border: "1px solid var(--color-border)" }}
                    >
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <div
                          className="rounded-4 d-flex align-items-center justify-content-center"
                          style={{ width: 52, height: 52, background: "var(--azul-logo-fondo)", color: "var(--naranja-cta)" }}
                        >
                          <i className="bi bi-search" style={{ fontSize: 24 }} aria-hidden="true"></i>
                        </div>
                        <div>
                          <div className="text-body-secondary" style={{ fontSize: 13 }}>Para compradores</div>
                          <h3 className="h4 fw-bold mb-0">Encuentra y reserva servicios</h3>
                        </div>
                      </div>

                      <div className="d-grid gap-3 mt-4">
                        <div className="d-flex gap-3">
                          <div className="fw-bold rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 34, height: 34, background: "var(--color-bg-surface)", color: "var(--color-text-primary)" }}>1</div>
                          <div>
                            <div className="fw-semibold">Busca lo que necesitas</div>
                            <div className="text-body-secondary" style={{ fontSize: 14 }}>
                              Explora categorías o escribe el servicio que estás buscando.
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-3">
                          <div className="fw-bold rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 34, height: 34, background: "var(--color-bg-surface)", color: "var(--color-text-primary)" }}>2</div>
                          <div>
                            <div className="fw-semibold">Compara y reserva</div>
                            <div className="text-body-secondary" style={{ fontSize: 14 }}>
                              Revisa fotos, precios, descripción, disponibilidad y elige la mejor opción.
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-3">
                          <div className="fw-bold rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 34, height: 34, background: "var(--color-bg-surface)", color: "var(--color-text-primary)" }}>3</div>
                          <div>
                            <div className="fw-semibold">Haz seguimiento</div>
                            <div className="text-body-secondary" style={{ fontSize: 14 }}>
                              Comunícate, paga y califica la experiencia desde Zervicy.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-4">
                        <button type="button" className="btn btn-dark" onClick={() => navigate("/busqueda")}>Buscar servicios</button>
                      </div>
                    </div>
                  </div>

                  {/* VENDEDORES */}
                  <div className="col-12 col-lg-6">
                    <div
                      className="h-100 rounded-4 p-4"
                      style={{ background: "var(--color-bg-surface-alt)", border: "1px solid rgba(var(--naranja-cta-rgb),0.22)" }}
                    >
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <div
                          className="rounded-4 d-flex align-items-center justify-content-center"
                          style={{ width: 52, height: 52, background: "var(--azul-logo-fondo)", color: "var(--naranja-cta)" }}
                        >
                          <i className="bi bi-shop" style={{ fontSize: 24 }} aria-hidden="true"></i>
                        </div>
                        <div>
                          <div className="text-body-secondary" style={{ fontSize: 13 }}>Para vendedores</div>
                          <h3 className="h4 fw-bold mb-0">Publica y recibe reservas</h3>
                        </div>
                      </div>

                      <div className="d-grid gap-3 mt-4">
                        <div className="d-flex gap-3">
                          <div className="fw-bold rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 34, height: 34, background: "var(--color-bg-surface)", color: "var(--naranja-cta)" }}>1</div>
                          <div>
                            <div className="fw-semibold">Crea tu servicio</div>
                            <div className="text-body-secondary" style={{ fontSize: 14 }}>
                              Agrega fotos, descripción, precios, paquetes y horarios.
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-3">
                          <div className="fw-bold rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 34, height: 34, background: "var(--color-bg-surface)", color: "var(--naranja-cta)" }}>2</div>
                          <div>
                            <div className="fw-semibold">Recibe la notificación</div>
                            <div className="text-body-secondary" style={{ fontSize: 14 }}>
                              Zervicy muestra tu servicio y te avisa cuando alguien hace una reserva.
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-3">
                          <div className="fw-bold rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 34, height: 34, background: "var(--color-bg-surface)", color: "var(--naranja-cta)" }}>3</div>
                          <div>
                            <div className="fw-semibold">Enfócate en trabajar</div>
                            <div className="text-body-secondary" style={{ fontSize: 14 }}>
                              Nosotros te ayudamos a organizar la venta; tú prestas un buen servicio.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-4 d-flex flex-wrap gap-2">
                        {usuario ? (
                          <>
                            <button type="button" className="btn btn-primary" onClick={irAPublicarServicio}>Publicar servicio</button>
                            <button type="button" className="btn btn-outline-secondary" onClick={irAMisServicios}>Ver mis servicios</button>
                          </>
                        ) : (
                          <>
                            <button type="button" className="btn btn-primary" onClick={() => enviarARegistrar("/vendedor/crear-editar-servicio")}>Crear cuenta</button>
                            <button type="button" className="btn btn-outline-secondary" onClick={() => enviarAIniciarSesion("/vendedor/servicios")}>Iniciar sesión</button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* BENEFICIOS */}
                <div className="row g-3 mt-4">
                  <div className="col-12 col-md-4">
                    <div className="d-flex align-items-center gap-3 p-3 rounded-4" style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)" }}>
                      <i className="bi bi-shield-check" style={{ fontSize: 24, color: "var(--azul-logo-claro)" }} aria-hidden="true"></i>
                      <div>
                        <div className="fw-semibold">Más confianza</div>
                        <div className="text-body-secondary" style={{ fontSize: 13 }}>Perfiles, reservas y calificaciones.</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="d-flex align-items-center gap-3 p-3 rounded-4" style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)" }}>
                      <i className="bi bi-credit-card" style={{ fontSize: 24, color: "var(--azul-logo-claro)" }} aria-hidden="true"></i>
                      <div>
                        <div className="fw-semibold">Pagos organizados</div>
                        <div className="text-body-secondary" style={{ fontSize: 13 }}>La reserva queda registrada en la plataforma.</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="d-flex align-items-center gap-3 p-3 rounded-4" style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)" }}>
                      <i className="bi bi-bell" style={{ fontSize: 24, color: "var(--azul-logo-claro)" }} aria-hidden="true"></i>
                      <div>
                        <div className="fw-semibold">Notificaciones</div>
                        <div className="text-body-secondary" style={{ fontSize: 13 }}>Te avisamos cuando hay actividad importante.</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>}

        {/* 4) Descargar la app */}
        <section className="mt-4 mb-4">
          <div
            className="card border-0 shadow-sm overflow-hidden"
            style={{ borderRadius: 24, background: "var(--azul-logo-fondo)" }}
          >
            <div className="card-body p-4 p-lg-5 text-white position-relative">
              <div
                className="position-absolute top-0 end-0 h-100 d-none d-lg-block"
                style={{
                  width: "42%",
                  background: "radial-gradient(circle at 70% 35%, rgba(var(--naranja-cta-rgb), 0.34), transparent 34%), radial-gradient(circle at 35% 70%, rgba(var(--azul-logo-claro-rgb), 0.42), transparent 38%)",
                  opacity: 0.95,
                }}
              />

              <div className="row g-4 align-items-center position-relative" style={{ zIndex: 1 }}>
                <div className="col-12 col-lg-7">
                  <span
                    className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-3"
                    style={{ background: "rgba(var(--blanco-rgb), 0.10)", border: "1px solid rgba(var(--blanco-rgb), 0.20)", fontSize: 13 }}
                  >
                    <i className="bi bi-phone" aria-hidden="true"></i>
                    Lleva Zervicy contigo
                  </span>

                  <h2 className="display-6 fw-bold mb-2">Descarga la app de Zervicy</h2>
                  <p className="lead mb-0" style={{ opacity: 0.9 }}>
                    Busca servicios, gestiona tus reservas o publica tus habilidades desde tu celular.
                  </p>
                </div>

                <div className="col-12 col-lg-5">
                  <div className="d-grid gap-3">
                    <a
                      href="https://apps.apple.com/co/app/zervicy/id6761780592"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-light btn-lg d-flex align-items-center justify-content-center gap-3 fw-semibold"
                      style={{ borderRadius: 16 }}
                      onClick={() => { pixelClickDescargaApp({ plataforma: "ios" }); gtagClickDescargaApp({ plataforma: "ios" }); ttqClickDescargaApp({ plataforma: "ios" }); eventoClickDescargaApp({ plataforma: "ios", usuarioId: usuario?.idUsuario }); }}
                    >
                      <i className="bi bi-apple" style={{ fontSize: 24 }} aria-hidden="true"></i>
                      Descargar en iOS
                    </a>

                    <a
                      href="https://play.google.com/store/apps/details?id=com.zervicy.app"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-outline-light btn-lg d-flex align-items-center justify-content-center gap-3 fw-semibold"
                      style={{ borderRadius: 16 }}
                      onClick={() => { pixelClickDescargaApp({ plataforma: "android" }); gtagClickDescargaApp({ plataforma: "android" }); ttqClickDescargaApp({ plataforma: "android" }); eventoClickDescargaApp({ plataforma: "android", usuarioId: usuario?.idUsuario }); }}
                    >
                      <i className="bi bi-google-play" style={{ fontSize: 22 }} aria-hidden="true"></i>
                      Descargar en Android
                    </a>
                  </div>

                  <div className="text-white-50 mt-3" style={{ fontSize: 13 }}>
                    Disponible en iPhone y Android.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
    }
    </>
    </div>
  );
}

export default Home;